import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

export const usePermiso = ({location, initialValue = true}) => {
    const [permitido, setPermitido] = useState(initialValue)
    const { permisos } = useSelector(state => state.logeo)
    useEffect(() => {
        const buscarPermiso = () => {
            let permiso = permisos.find( permiso =>  permiso?.Clave_Permiso  === location)
            if (permiso)
                setPermitido(true)
            else 
                setPermitido(false)
        }
        if (location !== "PK_Home" && permisos.length > 0)
            buscarPermiso()
        
    }, [location, permisos])
    return [permitido]
}